import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let stage = useDataValue({
    context: 'stage',
    viewPath: props.viewPath,
  })

  let collapsedStageLanes = useDataValue({
    context: 'collapsed_stage_lanes',
    viewPath: props.viewPath,
  })

  let changeCollapsedStageLanes = useDataChange({
    context: 'collapsed_stage_lanes',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let collapsed = collapsedStageLanes.includes(stage.id)
    if (collapsed) {
      changeCollapsedStageLanes(
        collapsedStageLanes.filter(id => id !== stage.id)
      )
    } else {
      changeCollapsedStageLanes([...collapsedStageLanes, stage.id])
    }
  }
}
